import { render, staticRenderFns } from "./FooterAma.vue?vue&type=template&id=dda8c03c&scoped=true&"
import script from "./FooterAma.vue?vue&type=script&lang=js&"
export * from "./FooterAma.vue?vue&type=script&lang=js&"
import style0 from "./FooterAma.vue?vue&type=style&index=0&id=dda8c03c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda8c03c",
  null
  
)

export default component.exports